import BasicRouterView from "../../../components/BasicRouterView.vue";

const verificarSubDominio = () => {
  let subdominio = window.location.host.split(".")[1]
    ? window.location.host.split(".")[0]
    : "";
  return subdominio;
};

const integracaoRoutes = {
  path: "integ",
  redirect: { name: "integracao-statusintegracao" },
  meta: {
    label: "Integração",
    icon: "info",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "integracao/integracao-status-integracao",
      name: "integracao-statusintegracao",
      meta: {
        label: "Integração Entregas",
        icon: "content_paste",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "int" */ "./views/IntegracaoStatus.vue"),
    },
    {
      path: "integracao/integracao-produtos",
      name: "integracao-produtos",
      meta: {
        label: "Integração Produtos",
        icon: "inventory",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "int" */ "./views/IntegracaoProdutos.vue"),
    },
    {
      path: "integracao/integracao-postos",
      name: "integracao-postos",
      meta: {
        label: "Integração Postos",
        icon: "room_preferences",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "int" */ "./views/IntegracaoPostos.vue"),
    },
    {
      path: "integracao/integracao-usuarios",
      name: "integracao-usuarios",
      meta: {
        label: "Integração Usuários",
        icon: "manage_accounts",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "int" */ "./views/IntegracaoUsuarios.vue"),
    },
    {
      path: "integracao/integracao-cadastro-produtos",
      name: "integracao-cadastro-produtos",
      meta: {
        label: "Cadastrar/Editar Produtos Integração",
        icon: "inventory",
        show: verificarSubDominio().includes("wilsonsons") ? true : false,
      },
      component: () =>
        import(
          /* webpackChunkName: "int" */ "./views/IntegracaoCadastrarProdutos.vue"
        ),
    },
    {
      path: "integracao/logs-integracao",
      name: "integracao-logs",
      meta: {
        label: "Log Integração Usuários",
        icon: "manage_accounts",
        show:
          verificarSubDominio().includes("staging-vale") ||
          verificarSubDominio().includes("vale-epiexpress")
            ? true
            : false,
      },
      component: () =>
        import(/* webpackChunkName: "int" */ "./views/IntegracaoLogs.vue"),
    },
    {
      path: "integracao/cadastro-cliente",
      name: "cadastro-cliente",
      meta: {
        label: "Cadastro de Clientes",
        icon: "person_add",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "int" */ "./views/IntegraçãoCadastroClientes.vue"
        ),
    },
    {
      path: "integracao/centro-planta",
      name: "integracao-centro-planta",
      meta: {
        label: "Centro de Custo - Planta",
        icon: "person_add",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "int" */ "./views/CentroCustoPlanta.vue"),
    },
    {
      path: "integracao/teste",
      name: "integracao-teste",
      meta: {
        label: "Integracao teste",
        icon: "manage_accounts",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "int" */ "./views/IntegracaoTeste.vue"),
    },
    {
      path: "integracao/lista-arquivos-integrados",
      name: "lista-arquivos-integrados",
      meta: {
        label: "Lista de Arquivos Integrados",
        icon: "content_paste",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "int" */ "./views/ListaArquivosIntegrados.vue"
        ),
    },
  ],
};

export default integracaoRoutes;
